module.exports = __webpack_public_path__ + "static/media/modicogryllus_frontalis_001_APA.677d1c2d.mp3";